import { useState } from 'react';
import { api } from '../lib/api';
import { useI18n } from '../lib/i18n';

/**
 * Modal chiquito: pide el número "call-from" la primera vez que alguien intenta un click-to-call
 * y todavía no lo configuró (feedback 2026-07-30, click-to-call desde el avatar). Al guardar,
 * dispara `onSaved` para que el caller reintente la llamada.
 */
export function CallFromPrompt({ onClose, onSaved }: { onClose: () => void; onSaved: () => void }) {
  const { t } = useI18n();
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);

  async function save() {
    if (!phone.trim()) return;
    setBusy(true);
    try { await api.post('/api/auth/call-from', { phone: phone.trim() }); onSaved(); }
    catch { /* best-effort, el caller reintenta igual */ onSaved(); }
    finally { setBusy(false); }
  }

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 4000, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={(e) => e.stopPropagation()} className="card" style={{ maxWidth: 380, width: '100%' }}>
        <h3 style={{ marginTop: 0 }}>{t('call.setting_label')}</h3>
        <p className="muted" style={{ fontSize: 'var(--fs-sm)' }}>{t('call.set_number_prompt')}</p>
        <input
          className="input"
          style={{ width: '100%' }}
          type="tel"
          autoFocus
          placeholder="(404) 555-0100"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') save(); }}
        />
        <div style={{ display: 'flex', gap: 8, marginTop: 14, justifyContent: 'flex-end' }}>
          <button className="btn ghost" onClick={onClose}>{t('common.cancel')}</button>
          <button className="btn" disabled={busy || !phone.trim()} onClick={save}>{t('call.save')}</button>
        </div>
      </div>
    </div>
  );
}
